module.exports = __webpack_public_path__ + "img/icon_roodie_video.16c35b81.svg";